const bindToContext = (funcName, context) => {
    context[funcName] = context[funcName].bind(context);
};

export default bindToContext;
